import { api } from "./api";

export interface IVideo {
  id: string;
  title: string;
  url: string;
}

/**
 * A coleção guarda o arquivo dentro de `video`, com o nome original do upload —
 * que costuma ter espaço e acento. Sem codificar, o player recebe uma URL
 * inválida e não toca.
 */
function toVideo(doc: any): IVideo {
  return {
    id: doc._id,
    title: doc.title,
    url: encodeURI(doc.video?.url ?? ""),
  };
}

/**
 * Último vídeo cadastrado em `upload_videos__c`. A coleção não tem campo que
 * identifique a página de destino, então o mais recente é o vigente — trocar o
 * vídeo é cadastrar um novo.
 */
export async function getLatestVideo(): Promise<IVideo | null> {
  const payload = [{ $sort: { created: -1 } }, { $limit: 1 }] as any;

  const { data } = await api.post(
    `database/upload_videos__c/aggregate`,
    payload
  );

  if (!Array.isArray(data) || data.length === 0) return null;

  return toVideo(data[0]);
}
